module.exports = __webpack_public_path__ + "img/gwyx-lxbxcrbxfc.4961e0a9.png";